export default __webpack_public_path__ + "favicon-152.png";